import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SessionCookies, FormStatus } from '@enums';
import { AppRoutes, SESSION_COOKIE_PATH } from '@constants';
import { SessionService } from '@services';

@Component({
  standalone: false,
  selector: 'digicem-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
})
export class ChangePasswordDialogComponent {
  public token: string;

  constructor(
    private dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    private cookieService: CookieService,
    private sessionService: SessionService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { token: string },
  ) {
    this.token = data.token;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  protected handleOnChangeStatus(status: FormStatus): void {
    switch (status) {
      case FormStatus.SENT:
        this.cookieService.delete(
          SessionCookies.needsPasswordChange,
          SESSION_COOKIE_PATH,
        );
        break;
      case FormStatus.FINISHED:
        this.dialogRef.close();
        break;
      case FormStatus.CLOSED:
        this.closeDialog();
        break;
      case FormStatus.EXPIRED:
        this.endSession();
        break;
    }
  }

  /**
   * A rejected token inside the portal means the session itself is no longer
   * valid: clear it and go to login.
   */
  private endSession(): void {
    this.sessionService.clear();
    this.dialogRef.close();
    this.router.navigate([`/${AppRoutes.LOGIN}`]);
  }
}
